var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'iframe-layout',
    'contenedor-main',
    {
      'no-padding-inline':
        _vm.$route.name === 'hotelReservationCalendar' ||
        _vm.$route.name === 'hotelReservationCalendar',
    },
  ],style:(_vm.containerStyles)},[_c('div',{staticClass:"container-fluid p-0"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }